import React, { useMemo, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Breadcrumbs,
  Link as MuiLink,
  TextField,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import DataAdminGrid from "../../components/dataAdminGrid/DataAdminGrid";
import DataGridInfoAlert from "../../components/dataAdminGrid/InfoAlert";
import {
  WELLS_BASE_URL,
  WELL_PK_FIELD,
  COLUMNS as BASE_COLUMNS,
} from "./wellsConfig";
import { ROUTES } from "../../constants";

function WellsPage() {
  const columns = useMemo(() => BASE_COLUMNS, []);
  const [searchText, setSearchText] = useState("");

  const normalizedNeedle = searchText.trim().toLowerCase();

  const rowMatchesSearch = useMemo(() => {
    if (!normalizedNeedle) return () => true;

    return (row) => {
      if (row?.well_ndx == null) return true;

      const searchable = [
        row?.well_ndx,
        row?.id_address,
        row?.id_well,
        row?.id_well_status,
        row?.id_well_report_tracking_number,
        row?.well_name,
        row?.id_district,
        row?.longitude,
        row?.latitude,
        row?.ft_elevation,
        row?.ft_measure_point,
        row?.grid_number,
        row?.tax_parcel,
        row?.id_ncdc_station,
        row?.well_report_static_water_level,
        row?.id_aquifer,
        row?.id_aquifer_strata,
        row?.sample_well,
        row?.gamma_log,
        row?.transducer_well,
        row?.monitoring_well,
        row?.method_measure,
        row?.monitoring_start_date,
        row?.monitoring_end_date,
        row?.comment,
      ]
        .filter((v) => v !== undefined && v !== null)
        .join(" ")
        .toLowerCase();

      return searchable.includes(normalizedNeedle);
    };
  }, [normalizedNeedle]);

  return (
    <Box>
      <Helmet title="Wells Management" />

      <Typography variant="h3" gutterBottom display="inline">
        Wells Management
      </Typography>

      <Breadcrumbs sx={{ mt: 4 }} aria-label="breadcrumb">
        <MuiLink component={RouterLink} to={ROUTES.LANDING}>
          Home
        </MuiLink>
        <Typography>Wells</Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 6 }} />
      <DataGridInfoAlert title="Manage wells:" />

      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <TextField
          fullWidth
          size="small"
          label="Search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Box>

      <DataAdminGrid
        baseUrl={WELLS_BASE_URL}
        columns={columns}
        primaryKeyField={WELL_PK_FIELD}
        rowFilter={rowMatchesSearch}
      />
    </Box>
  );
}

export default WellsPage;
